import React from 'react';
import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import styled from 'styled-components';

import ReactTooltip from 'react-tooltip';
import { Box, Text } from 'grommet';


const StyledTooltip = styled(ReactTooltip)`
  font-family: inherit;
  border-radius: 6px;
`;

const TruncatedTooltipText = ({
  small,
  text = null,
  textColor,
  noDataText,
  tooltipBg,
  truncateCutoff = 117,
}) => {
  const truncateText = (str) => ((str.length > truncateCutoff) ? `${str.substring(0, truncateCutoff - 3)}...` : str);
  const displayText = text ? truncateText(text) : noDataText;
  const tooltipUid = uniqid();

  return (
    <Box
      direction="row"
      gap="0.55rem"
      align="center"
      width="100%"
      height="100%"
    >
      <Text
        size={small ? '1.2rem' : '1rem'}
        color={textColor}
        weight={small ? 600 : 500}
        data-for={`${tooltipUid}-tooltip`}
        data-tip={text}
      >
        {displayText}
      </Text>
      {!small && text?.length > truncateCutoff && (
        <StyledTooltip
          id={`${tooltipUid}-tooltip`}
          arrowColor={tooltipBg}
          backgroundColor={tooltipBg}
          place="bottom"
          effect="solid"
          delayShow={300}
        />
      )}
    </Box>
  );
};

TruncatedTooltipText.propTypes = {
  small: PropTypes.bool.isRequired,
  text: PropTypes.string,
  textColor: PropTypes.string.isRequired,
  noDataText: PropTypes.string.isRequired,
  tooltipBg: PropTypes.string.isRequired,
  truncateCutoff: PropTypes.number,
};

export default TruncatedTooltipText;
